import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const templates = {
  namespaced: true,
  state: {
    templates: null
  },
  mutations: {
    setTemplates(state, data){
      state.templates = data.data;
      state.paginate = data;
    }
  },
  actions: {
    fetchTemplates: ({commit}, all_results = false) =>
      axios.get(`/ajax/reports/get-my-templates${all_results ? `?all_results=${all_results}` :''}`)
        .then(({ data }) => {
          commit('setTemplates', data);
        }),
    createTemplate: ({dispatch}, payload) =>
      new Promise((resolve, reject) => {
        axios.post('/ajax/reports/create-template',{
            data: payload,
          })
          .then(response => {
            dispatch('fetchTemplates').then(() => {
              resolve(response.data);
            });
          })
          .catch((e) => axiosCatchHandler(e, ({response}) => {
            reject(response.data.errors);
          }));
      }),
    navigatePagination: ({commit}, {url}) =>
      axios.get(url)
        .then(({ data }) => commit('setTemplates', data)),
    searchTemplates: ({commit}, payload) =>
      axios.get(`/ajax/reports/get-my-templates?search=${payload}`)
        .then(({ data }) => commit('setTemplates', data)),
    deleteTemplates: ({dispatch}, selected) =>
      axios.post('/ajax/reports/delete-templates', {
          data: selected
        })
        .then(response => {
          dispatch('fetchTemplates');
          return response;
        }),
  }
};

export default templates;
